import React, {Component} from 'react';
import store from 'store';

import {Button, Card, CardBody, Col, Container} from "reactstrap";
import {Link} from 'react-router';

import Loader from '../../components/display/Loader';

import Logo from '../../assets/svg/logo-blue.svg';
import Star from '../../assets/svg/success-star.svg';
import Broken from '../../assets/svg/broken-link.svg';
import PolyUtil from "../../util/PolyUtil";

class ConfirmEmailContainer extends Component {
    state = {
        status: ''
    };

    componentWillMount() {
        const {token, user_id} = this.props.params;
        //hit api with token

        return PolyUtil.fetchWrapper('/api/verify/email/' + user_id + '/' + token + '/',
            {method: 'POST'}
        ).then((data) => {
            this.setState({status: 'ok'});
        }).catch((error) => {
            this.setState({status: 'invalid'});
        });
    }

    render() {
        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <img style={{maxWidth: '100px'}} src={Logo} alt="PolyRents"/>
                </div>

                <Loader spin isLoading={this.state.status === ''}>
                    <Container>
                        <Col xs={12} md={{size: 6, offset: 3}}>
                            <Card className="pr-card">
                                <CardBody style={{textAlign: 'center'}}>
                                    {
                                        this.state.status === 'ok' ? (
                                            <div>
                                                <img src={Star} style={{height: '100px', width: '100px', marginBottom: '1em'}} alt=""/>
                                                <h2 className="text-center text-success">You're all good to go!</h2>
                                                <p className="text-center">Your email has been verified!</p>
                                                <hr/>
                                                <div className="center">
                                                    {
                                                        (store.get('access_token') && store.get('type')) ? (
                                                            <Button color="primary" outline tag={Link} to="/dashboard/">Dashboard</Button>
                                                        ) : (
                                                            <Button color="primary" outline tag={Link} to="/login/">Log In</Button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <img src={Broken} style={{height: '100px', width: '100px', marginBottom: '1em'}} alt=""/>
                                                <h2 className="text-center text-danger">Hmmmm...</h2>
                                                <p className="text-center">It appears this link has expired or is invalid.</p>
                                                <p className="text-center">If you got here from an email, try returning to your account settings and clicking 'Resend Email' under confirmation.</p>

                                            </div>
                                        )
                                    }

                                </CardBody>
                            </Card>
                        </Col>
                    </Container>
                </Loader>
            </div>
        );
    }
}

export default ConfirmEmailContainer;


// WEBPACK FOOTER //
// ./src/containers/confirm_email/ConfirmEmailContainer.js